<template>
  <div class="wizard">
    <SubscriptionNotice />
    <div class="app-container">
      <div class="route-container route-container--skinny">
        <Header />
        <div class="route-container-inner">
          <router-view />
          <AdviceNotice />
        </div>
      </div>
      <section class="controls">
        <router-link
          class="ctrl ctrl--begin"
          :to="{ path: '/register/new-member' }"
        >
          Back
        </router-link>
      </section>
    </div>
    <spinner />
  </div>
</template>

<script>
// @ is an alias to /src
import AdviceNotice from "@/components/AdviceNotice";
import Header from "@/components/MembershipOptionsHeader";
import Spinner from "@/components/Spinner";
import SubscriptionNotice from "@/components/SubscriptionNotice";

export default {
  name: "Wizard",
  components: {
    AdviceNotice,
    Header,
    Spinner,
    SubscriptionNotice,
  },
};
</script>

<style lang="scss">
.wizard {
  .question-block {
    padding: 120px 32px;
    text-align: center;

    &-question {
      font-size: 18px;
      font-weight: 700;
      line-height: 36px;
    }
  }

  .question-control {
    &--boolean {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-left: -16px;

      .radio-input {
        margin-left: 16px;

        &--btn {
          input[type="radio"] {
            display: none;
          }

          label {
            background: #ffffff;
            border: 1px solid var(--primary);
            border-radius: 50px;
            box-sizing: border-box;
            color: var(--primary);
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            padding: 3px;
            width: 130px;

            &:before {
              display: none;
            }

            &:hover {
              color: #ffffff;
              background-color: var(--primary);
              transition: all 0.4s linear;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.controls {
  margin-bottom: 24px;
  text-align: center;

  a {
    color: var(--primary);
    text-decoration: underline;
  }
}
</style>
